import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
} from "../services/types/ComponentTypes";

export const screen_150_estimate_approval: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Estimate Approval",
    style: {
      // backgroundColor: "#F1F8E9",
    },
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "approval_add",
        columnNumber: "m1 t1 w1",
        TableName: "service_est_approval",
        DisplayName: "Approval",
        Workflow: "service",
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          padding: 10,
        },
        Fields: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [


              {
                componentType: ComponentType.BUTTON,
                name: "lock",
                Label: "lock",
                BindValue: "lock",
                onPressAction: "unlock",
                ScreenId: "150",
                ActionType: "Unlock",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Approval details",
            BindValue: "con_approval_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "Approval No.",
                PlaceHolder: "Will be auto generated...",
                IsMandatory: false,
                BindValue: "txt_approved_number",
                Json_Attribute: "approved_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                AutoPopulate: true,
                IsReadOnly: true,
                AutoPopulate_format: "VAP_[******]",
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Estimation No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "parentid",
                Json_Attribute: "parent_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                showInSummary: false,
                IsReadOnly: true,
                LookupName: "estimation_items",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Approve status",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "approve_status",
                Json_Attribute: "approve_status",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
               // LookupName: "Approve",
                IsVerticalView: true,
                options: [
                  {
                    label: "Approved",
                    value: "Approved",
                  },
                  {
                    label: "Rejected",
                    value: "Rejected",
                  },
                  {
                    label: "Put on hold",
                    value: "Put on hold",
                  },
                ],
              },
              {
                Label: "",
                BindValue: "veh_details",
                componentType: ComponentType.REPORT,
                IncludeLabel: true,
                Settings: "EstimationApproval",
                Parent_Field: "parentid",
              },
            ],
          },
        ],
      },
      {
        componentType: LayoutTypes.GRID,
        columnNumber: "m1 t2 w1",
        childComponents: [
          {
            componentType: ComponentType.BUTTON,
            name: "Submit",
            Label: "Submit",
            BindValue: "btn_submit",
            onPressAction: "save",
            ScreenId: "150",
            ActionType: "Add",
            style: {
              backgroundColor: "var(--primary-green)",
            },
          },
          {
            componentType: ComponentType.BUTTON,
            name: "Cancel",
            Label: "Cancel",
            BindValue: "btn_cancel",
            onPressAction: "navigate",
            ActionType: "Navigate",
            style: {
              backgroundColor: "var(--secondary-gray)",
            },
          },
        ],
      },
    ],
  },
];

